import { Box, Checkbox, FormControl, FormHelperText, FormLabel } from "@mui/joy";
import { SxProps } from "@mui/joy/styles/types";
import { useController, useFormContext } from "react-hook-form";

type Props = {
  name: string;
  label: string;
  options: { name: string; value: string }[];
  containerSx?: SxProps;
};

export default function CheckboxSelectInput({ name, label, options, containerSx }: Props) {
  const { control } = useFormContext();
  const { field, fieldState } = useController({
    name,
    control,
  });

  const selectedValues = field.value as string[];

  return (
    <FormControl error={!!fieldState.error}>
      <FormLabel>{label}</FormLabel>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 1,
          ...containerSx,
        }}
      >
        {options.map((option) => (
          <Checkbox
            key={option.value}
            checked={selectedValues.includes(option.value)}
            onChange={(e) => {
              if (e.target.checked) {
                field.onChange([...selectedValues, option.value]);
              } else {
                field.onChange(selectedValues.filter((value) => value !== option.value));
              }
            }}
            label={option.name}
          />
        ))}
      </Box>
      {fieldState.error ? <FormHelperText>{fieldState.error.message}</FormHelperText> : null}
    </FormControl>
  );
}
